import React from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { makeStyles } from "@mui/styles";
import { InputAdornment, TextField } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  calender: {
    "& div": {
      fontSize: "14px !important",
      fontWeight: 600,
      color: "rgba(52, 64, 84, 1)",
    },
    "& span": {
      fontSize: "14px !important",
      fontWeight: 600,
      color: "rgba(52, 64, 84, 1)",
    },
    "& button": {
      fontSize: "14px !important",
      color: "rgba(52, 64, 84, 1)",
    },
    "& .MuiDialog-paper": {
      minWidth: "unset !important",
      width: "Fit-Content !important",
    },
  },
  datePicker: {
    "flex-direction": "row-reverse",
    fontSize: "1.4rem !important",
    "& fieldSet": {
      border: "none",
    },
    // marginTop: "0.6rem",
    width: "100% !important",
    background: "#F2F4F7",
    border: "1px solid #F2F4F7 !important",
    boxSizing: "border-box",
    boxShadow: "0px 1px 2px rgb(16 24 40 / 5%)",
    borderRadius: "0.8rem",
    justifyContent: "flex-end",
    "& input": {
      width: "fit-content",
      fontSize: "16px !important",
      padding: "1rem 1.4rem !important",
      color: "rgba(16, 24, 40, 1)",
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #FFFFFF !important",
        boxShadow:
          "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
      },
    },

    "&:hover": {
      // border:"none",
      "& .MuiOutlinedInput-notchedOutline": {
        // border: '1px solid #D0D5DD !important'
      },
    },
    "& button": {
      fontSize: "1.4rem",
      transform: "scale(1.5)",
    },
    " &.MuiButtonBase-root-MuiPickersDay-root.Mui-selected ": {
      background: "rgba(127, 86, 217, 1) !important",
    },
  },
  helperText: {
    fontSize: "10px !important",
    margin: "0.2rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    color: "#d32f2f !important",
  },
  label: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#344054",
    marginBottom: "0.6rem",
  },
}));

const DesktopDatePickerComponent = ({
  helperText,
  value,
  minDate,
  maxDate,
  onChangeDate,
}) => {
  const classes = useStyles();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        fontSize="2rem"
        inputFormat="MM/DD/YYYY"
        minDate={minDate ? minDate : new Date()}
        maxDate={maxDate}
        value={value ? value : ""}
        className="test"
        PaperProps={{ className: classes.calender }}
        DialogProps={{ className: classes.calender }}
        PopperProps={{
          placement: "bottom-start",
          "&.MuiButtonBase-root-MuiPickersDay-root": {
            fontSize: "2rem !important",
          },
        }}
        onChange={(e) => (e ? onChangeDate(e["$d"]) : onChangeDate(""))}
        InputProps={{
          className: classes.datePicker,
          endAdornment: (
            <InputAdornment position="start">
              <CalendarTodayOutlinedIcon
                style={{
                  fontSize: "2rem",
                  marginLeft: "1.5rem",
                  cursor: "pointer",
                  color: "#667085",
                }}
              />
            </InputAdornment>
          ),
        }}
        renderInput={(params) => (
          <TextField
            style={{ verticalAlign: "middle", width: "160px" }}
            placeholder="MM-DD-YYYY"
            {...params}
            helperText={helperText}
            FormHelperTextProps={{
              classes: {
                root: classes.helperText,
              },
            }}
            sx={[
              {
                "&>div:first-of-type": {
                  border:
                    helperText !== ""
                      ? "1px solid red !important"
                      : "1px solid #F2F4F7 !important",
                  borderRadius: "0.8rem",
                  flexDirection: "row",
                  background: "#fff",
                },
                width: "100%",
              },
            ]}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DesktopDatePickerComponent;
